import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Dialog from '@material-ui/core/Dialog';

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import Legendas from '../components/Legendas'
import AutoComp from '../components/AutoComp'
import FrDatePicker from '../components/FrDatePicker'
import { documentInverted } from 'react-icons-kit/entypo/documentInverted'
import { MDBContainer, MDBIframe } from "mdbreact";
import {fileExcel} from 'react-icons-kit/icomoon/fileExcel'
import ReactExport from "react-data-export";


import api from '../services/api'
import { formToObject, objectToQueryString, paramsToObject, populateForm, getUserCode, debounce, isEmpty } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';
import { mCPF } from '../utils/masks';

const swal = withReactContent(Swal)

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function Contratos(props) {
  const [data, setData] = useState([])
  const [exportData, setExportData] = useState([])
  const [filter, setFilter] = useState({})
  const [dadosCores, setDadosCores] = useState([])
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [contrato, setContrato] = useState(0)
  const [arquivoTermo, setArquivoTermo] = useState(0)
  const [cliente, setCliente] = useState('')
  const [termo, setTermo] = useState(0)
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [cli, setCli] = useState()
  const [emp, setEmp] = useState()
  const [resp, setResp] = useState()
  const [comboTco, setComboTco] = useState([{ value: '', display: '' }])
  const [comboContrato, setComboContrato] = useState([{ value: 'A', display: 'Assinar' }, { value: 'E', display: 'Enviar' }])
  const [comboTermo, setComboTermo] = useState([{ value: 'A', display: 'Assinar' }, { value: 'E', display: 'Enviar' }, { value: 'I', display: 'Imprimir' }])
  const [selected, setSelected] = useState([])
  const [showModalContrato, setShowModalContrato] = useState(false)
  const [showModalTermo, setShowModalTermo] = useState(false)
  const [showModalTermoPdf, setShowModalTermoPdf] = useState(false)
  const [comboSed, setComboSed] = useState([{ value: '', display: '' }])

  const [comboAtivo, setComboAtivo] = useState([{ value: ' and (data_cancelamento is null and (data_fim is null or data_fim > current_date))', display: 'Ativo' },
  { value: 'and (data_cancelamento is not null or data_fim <= current_date)', display: 'Inativo' }
  ])

  const [comboSct, setComboSct] = useState([{ value: '', display: '' }])

  const columns = [
    { id: 'situacao', icon: true, numeric: false, label: '', align: 'left', minWidth: 50 },
    { id: 'nomesct', numeric: false, label: 'Situação', align: 'left', minWidth: 50 },
    { id: 'pk_cto', numeric: false, label: 'Nº Contrato', align: 'left', minWidth: 50 },
    { id: 'nomecli', numeric: false, label: 'Cliente', align: 'left', minWidth: 200 },
    { id: 'data_inicio', date: true, numeric: false, label: 'Data Início', align: 'left', minWidth: 200 },
    { id: 'data_fim', date: true, numeric: false, label: 'Data Vencimento', align: 'left', minWidth: 200 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      let tela = 'Contratos'
      setenableAdd(await api.getAcessos(tela, 'Inclusao'))
      setenableEdit(await api.getAcessos(tela, 'Alteracao'))
      setenableDel(await api.getAcessos(tela, 'Exclusao'))

      setComboTco(await api.getComboData('tipo_contrato'))
      setComboSed(await api.getComboDataWhere('sedes', "?fk_usu=" + getUserCode()))
      setComboSct(await api.getComboData('situacao_contrato'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      if (query.fk_cli)
        setCli(query.fk_cli)
      if (query.fk_resp)
        setResp(query.fk_resp)
      if (query.vigente)
        query.ativo = ' and (data_cancelamento is null and (data_fim is null or data_fim > current_date))'

      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
        // getData(event)

      }
    }

    fetchData()
  }, [])


  function getData(e) {
    e.preventDefault()
    try {
      var formData = new FormData(document.getElementById('searchForm'))
      var queryObject = formToObject(formData)
      if (!isEmpty(queryObject)) {

        queryObject.buscar = true
        
        setFiltered(true)
        window.history.replaceState({ filtered: true }, 'filter', "/salute/contratos?" + objectToQueryString(queryObject));
        swal.fire({
          html: <FrLoading text="Buscando dados..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        api.get("situacao_contrato?ativo=S").then(r=>{
          setDadosCores(r.data)
        })

        api.get("contratos/exportData", { params: queryObject }).then(r=>{
          setExportData(r.data)
          console.log(r.data)
        })
  
        api.get('/usuarios/pegaSedes?pk_usu=' + getUserCode()).then(r => {
          let sedes = ''
          if (r.data[0]) {
            sedes = r.data[0].sedes
            queryObject.sedes = sedes
          }
  
          api.get('/contratos', { params: queryObject }).then(r => {
            setData(r.data)
            swal.close()
          })
        })
      } else {
        swal.fire({
          title: 'Nenhum filtro informado!',
          html: '<p>Informe ao menos um filtro para realizar a busca.',
          icon: 'warning'
        })
  
      }
    } catch (error) {
      window.location.reload()
    }

  }


  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/contratos');
    document.getElementById('searchForm').reset()
    setEmp('')
    setCli('')
    setResp('')
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      case 'fk_cli':
        setCli(e.target.value);
        break

      case 'fk_emp':
        setEmp(e.target.value);
        break

      case 'fk_resp':
        setResp(e.target.value);
        break

      default:
        auxValues[e.target.name] = e.target.value;
    }
    setFilter(auxValues);
  };

  const handleChangeModal = (e) => {
    switch (e.target.name) {
      case 'contrato':
        setContrato(e.target.value);
        break;
      case 'termo':
        setTermo(e.target.value);
        break;
      case 'cliente':
        setCliente(e.target.value);
    }
  };


  useEffect(() => {
    const fetchCli = async () => {
      const auxValues = { ...filter };
      auxValues["fk_cli"] = cli;
      auxValues["nomecli"] = ''
      if (cli > 0) {
        await api.get("/clientes?pk_cli=" + cli).then((r) => {
          if (r.data[0]) {
            auxValues["nomecli"] = r.data[0].nome;

          }
        });
      }
      setFilter(auxValues);
    };
    const debouncedFetchCli = debounce(fetchCli, 300);
    debouncedFetchCli();
    
  }, [cli]);

  function limpaModal() {
    setShowModalContrato(false)
    setShowModalTermo(false)
    setShowModalTermoPdf(false)
    setContrato(0)
    setTermo(0)
  }


  function abreModalContrato(e) {
    e.preventDefault()
    limpaModal()
    if (selected.length > 1) {
      return swal.fire('Multiplos registros', 'Operação permitida para um único registro selecionado!', 'error')
    }
    if (selected.length == 0) {
      return swal.fire('Nenhum registro', 'Selecione um registro para realizar a operação!', 'error')
    }
    setShowModalContrato(true)

  }

  function testeTermo(e) {
    e.preventDefault()
    if (selected.length > 1) {
      return swal.fire('Multiplos registros', 'Operação permitida para um único registro selecionado!', 'error')
    }
    if (selected.length == 0) {
      return swal.fire('Nenhum registro', 'Selecione um registro para realizar a operação!', 'error')
    }
    setShowModalTermo(true)

  }

  function confirmaModalTermo() {
    if (termo == 0) {
      return swal.fire('Selecione uma opção!', 'É necessário selecionar uma opção para operação.', 'error')
    }
    if (termo == 'I') {
      imprimeTermo()
    } else {

      mandaTermoDocusign()
    }

  }

  function imprimeTermo() {
    api.get('/termo_ciencia/mostraPdf?pk_cto=' + selected[0], { responseType: 'blob' }).then(r => {
      let data = URL.createObjectURL(r.data)
      setArquivoTermo(data)
      setShowModalTermoPdf(true)
    })
  }

  function mandaTermoDocusign() {
    // let href = 'https://account-d.docusign.com/oauth/auth?response_type=token&scope=impersonation+signature&client_id=174ad6ae-917d-4401-8fcc-d1bfa5b51eef&redirect_uri=' + window.location.origin + '/salute/callback'
    let docusignData = {
      acao: termo,
      operacao: 'T',
      redirectUrl: window.location.href,
      pk_cto: selected[0],
      tipoDoc: 'T',
    }
    localStorage['docusignData'] = JSON.stringify(docusignData)
    api.post('/envelope', {tipoDoc: 'T', pk_cto: selected[0], redirectUrl: window.location.href}).then(r => {
      console.log(r.status, r.data)
      localStorage['docusignData'] = JSON.stringify(docusignData)
      if (r.data.consentUrl) {
        window.location = r.data.consentUrl
      } else if (r.data.signingUrl) {
        window.location= r.data.signingUrl
      }
    })
  }

  function confirmaModalContrato() {
    // let href = 'https://account-d.docusign.com/oauth/auth?response_type=token&scope=impersonation+signature&client_id=174ad6ae-917d-4401-8fcc-d1bfa5b51eef&redirect_uri=' + window.location.origin + '/salute/callback'
    let docusignData = {
      acao: contrato,
      pk_cto: selected[0],
      redirectUrl: window.location.href,
      tipoDoc: 'C'
    }
    api.post('/envelope', {tipoDoc: 'C', pk_cto: selected[0], redirectUrl: window.location.href}).then(r => {
      console.log(r.status, r.data)
      localStorage['docusignData'] = JSON.stringify(docusignData)
      if (r.data.consentUrl) {
        window.location = r.data.consentUrl
      } else if (r.data.signingUrl) {
        window.location= r.data.signingUrl
      }
    })
  }


  useEffect(() => {
    const fetchCli = async () => {
      const auxValues = { ...filter };
      auxValues["fk_resp"] = resp;
      auxValues["nomeresp"] = ''
      if (resp > 0) {
        await api.get("/clientes?pk_cli=" + resp).then((r) => {
          if (r.data[0]) {
            auxValues["nomeresp"] = r.data[0].nome;

          }
        });
      }
      setFilter(auxValues);
    };
    fetchCli();
  }, [resp]);


  useEffect(() => {
    const fetchEmp = async () => {
      const auxValues = { ...filter };
      auxValues["fk_emp"] = emp;
      auxValues["nomeemp"] = ''
      if (emp > 0) {
        await api.get("/empresas?pk_emp=" + emp).then((r) => {
          if (r.data[0])
            auxValues["nomeemp"] = r.data[0].razao_social;
        });
      }
      setFilter(auxValues);
    };
    fetchEmp();
  }, [emp]);

  function chamaRegistro(e) {
    e.preventDefault();
    window.location.href = "/salute/contratos/registro"

  }


  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Contratos</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <div>
          <Dialog aria-labelledby="simple-dialog-title" open={showModalTermoPdf} fullWidth={true} maxWidth={'lg'}>
            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">
                <MDBContainer className="text-center">
                  <MDBIframe src={arquivoTermo} />
                </MDBContainer>
                <button onClick={limpaModal}> Sair </button>
              </div>
            </div>
          </Dialog>
        </div>
        <div >
          <Dialog aria-labelledby="simple-dialog-title" open={showModalContrato} fullWidth={true} maxWidth={'xs'}>
            <div className="defaultHeader">
              <h3>Contrato</h3>
            </div>
            <div className="ManutContent" >
              <FrSelect
                value={contrato || 0}
                style={{ width: 250, }}
                name="contrato"
                id="contrato"
                label='Opção'
                data={comboContrato}
                onChange={handleChangeModal}
              />



            </div>
            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">

                <button onClick={confirmaModalContrato}> Confirmar</button>

                <button onClick={limpaModal}> Sair </button>
              </div>
            </div>
          </Dialog>
        </div>
        <div >
          <Dialog aria-labelledby="simple-dialog-title" open={showModalTermo} fullWidth={true} maxWidth={'xs'}>
            <div className="defaultHeader">
              <h3>Termo de Ciência</h3>
            </div>
            <div className="ManutContent" >
              <FrSelect
                value={termo || 0}
                style={{ width: 250, }}
                name="termo"
                id="termo"
                label='Opção'
                data={comboTermo}
                onChange={handleChangeModal}
              />




            </div>
            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">

                <button onClick={confirmaModalTermo}> Confirmar</button>

                <button onClick={limpaModal}> Sair </button>
              </div>
            </div>
          </Dialog>
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrTextInput
                value={filter.pk_cto || ''}
                style={{ width: 100 }}
                name="pk_cto"
                id="pk_cto"
                color="#333333"
                label="Nº Contrato"
                variant="outlined"
                size="small"
                onChange={handleChange}
                autoFocus
              />

              <FrTextInput
                value={mCPF(filter.cpf) || ''}
                style={{ width: 130 }}
                name="cpf"
                id="cpf"
                color="#333333"
                label="CPF"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />

              <FrTextInput
                value={(filter.fk_cli) || ''}
                style={{ width: 130 }}
                name="fk_cli"
                id="fk_cli"
                color="#333333"
                label="Código Cliente"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />

              <AutoComp
                value={filter.nomecli || ""}
                valor={cli}
                width={400}
                tabela={'clientes'}
                chave={'nome'}
                name="fk_cli"
                id="fk_cli"
                label='Cliente'
                data={comboCli}
                setValue={setCli}
                form={'searchForm'}
                manut={'contratos'}
              />

              <AutoComp
                value={filter.nomeresp || ""}
                valor={resp}
                width={400}
                tabela={'clientes'}
                chave={'nome'}
                name="fk_resp"
                id="fk_resp"
                label='Responsável'
                data={comboCli}
                setValue={setResp}
                form={'searchForm'}
                manut={'contratos'}
              />

              <FrSelect
                value={filter.fk_tco || -1}
                style={{ width: 150 }}
                name="fk_tco"
                id="fk_tco"
                label='Tipo'
                data={comboTco}
                onChange={handleChange}
                mostraTodos
              />

              <FrSelect
                value={filter.fk_sct || -1}
                style={{ width: 150 }}
                name="fk_sct"
                id="fk_sct"
                label='Situação'
                data={comboSct}
                onChange={handleChange}
                mostraTodos
              />

              <br />

              <FrDatePicker
                value={(filter.dataini || '').split('T')[0]}
                name="dataini"
                id="dataini"
                color="#49573B"
                label="Período Início Contrato"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim || '').split('T')[0]}
                name="datafim"
                id="datafim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}

              />


              <FrDatePicker
                value={(filter.dataini_fim || '').split('T')[0]}
                name="dataini_fim"
                id="dataini_fim"
                color="#49573B"
                label="Período Fim Contrato"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim_fim || '').split('T')[0]}
                name="datafim_fim"
                id="datafim_fim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}

              />

              <FrDatePicker
                value={(filter.dataini_canc || '').split('T')[0]}
                name="dataini_canc"
                id="dataini_canc"
                color="#49573B"
                label="Período Cancel.Contrato"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim_canc || '').split('T')[0]}
                name="datafim_canc"
                id="datafim_canc"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.fk_sed || -1}
                style={{ width: 150 }}
                name="fk_sed"
                id="fk_sed"
                label='Unidade'
                data={comboSed}
                onChange={handleChange}
                mostraTodos
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <button onClick={chamaRegistro}>
                  <Icon icon={ic_add_box} size={18} />
                  Novo Registro
                </button>}
              <button onClick={abreModalContrato}>
                <Icon icon={documentInverted} size={18} />
                Contrato
              </button>
              <button onClick={testeTermo}>
                <Icon icon={documentInverted} size={18} />
                Termo
              </button>

              <ExcelFile 
                  element={
                    <button 
                      type='button'  
                      
                    >
                      <Icon icon={fileExcel} size={18} />
                      Exportar XLS
                    </button>
                  } 
                  filename="Contratos">

                <ExcelSheet data={exportData} name="Contratos">
                  <ExcelColumn label="Contrato" value="contrato" />
                  <ExcelColumn label="Cliente" value="cliente" />
                  <ExcelColumn label="Responsável" value="responsavel" />
                  <ExcelColumn label="Início" value="inicio" />
                  <ExcelColumn label="Término" value="termino" />
                  <ExcelColumn label="Forma de Pagamento" value="forma_pagamento" />
                  <ExcelColumn label="Tipo de Contrato" value="tipo_contrato" />
                  <ExcelColumn label="Renovação Automática" value="renova_automatico" />
                  <ExcelColumn label="Sede" value="sede" />
                  <ExcelColumn label="Motivo Não Renovação" value="motivo_nao_renovacao" />
                  <ExcelColumn label="Data Cancelamento" value="data_cancelamento" />
                  <ExcelColumn label="Mensalidade" value="mensalidade" />
                </ExcelSheet>
              </ExcelFile>
            </div>
          </form>
        <Legendas legenda={dadosCores} />
        </div>

        <div className={"tableDiv" + (props.frame && data.length > 0 ? '-frame' : '')}>
          <FrTable
            ctr={'/salute/contas_receber?'}
            link={window.location.hostname + '/salute/cartao?id='}
            width={175}
            pdf={'/salute/clientes?pk_cli='}
            historicos={true}
            startOrder='desc'
            startOrderBy='pk_cto'
            regName="contratos"
            frame={props.frame}
            columns={columns}
            searched={filtered}
            codeName="pk_cto"
            mostraCheck={"S"}
            page={'contratos'}
            data={data}
            selected={selected}
            setSelected={setSelected}
            enableEdit={enableEdit}
            enableDel={enableDel}
            trocaTitular
            printCartao
            cancelarContrato
          />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Contratos;